export const redirectAfterSurgery = (history, match) => {
  if (!match?.uuid || !match?.surgeon_slug) {
    history.push(`member/conversations`);
    return;
  }

  history.push(`/member/mentor-matches/${match.uuid}/${match.surgeon_slug}`);
};
